import EventEmitter from 'eventemitter3';

// sdk内部通信用
export const innerEmitter = new EventEmitter();
